// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LrPr","col":"styles_col__1hyq4"};